'use client';

import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import Icon from '../Icon';

interface MeSnapshotBlockProps {
    title: string;
    text: string | undefined;
    rating: number;
    isFinal?: boolean; // Для подсветки "Стало"
}

const PRIMARY_COLOR = "var(--bs-primary)";

export default function MeSnapshotBlock({ title, text, rating, isFinal }: MeSnapshotBlockProps) {
    const hasText = !!text?.trim();

    const getGlowClass = (rating: number): string => {
        if (rating >= 10) return 'glow-rating-10';
        if (rating >= 9) return 'glow-rating-9';
        if (rating >= 8) return 'glow-rating-8';
        if (rating >= 7) return 'glow-rating-7';
        if (rating >= 6) return 'glow-rating-6';
        if (rating >= 5) return 'glow-rating-5';
        if (rating >= 4) return 'glow-rating-4';
        if (rating >= 3) return 'glow-rating-3';
        if (rating >= 2) return 'glow-rating-2';
        if (rating >= 1) return 'glow-rating-1';
        return 'glow-rating-0';
    };

    const getRatingLabel = (rating: number): string => {
        if (rating >= 10) return 'Идеально!';
        if (rating >= 8) return 'Очень близко';
        if (rating >= 6) return 'Хорошо';
        if (rating >= 4) return 'Средне';
        if (rating >= 2) return 'Требует доработки';
        return 'Не определено';
    };

    const glowClass = hasText ? getGlowClass(rating) : 'glow-rating-0';
    const ratingLabel = getRatingLabel(rating);

    return (
        <div className={`me-block ${glowClass} ${isFinal ? 'me-block-final' : ''}`}>
            <div className="me-block-header">
                <h2 className="me-block-title">{title}</h2>
            </div>
            <div className="me-block-content">
                {hasText ? (
                    <div className="me-block-text">{text}</div>
                ) : (
                    <div className="me-block-empty">
                        {isFinal ? 'Без изменений' : 'Нет данных'}
                    </div>
                )}
            </div>
            {hasText && (
                <div className="me-block-footer">
                    <div className="me-rating-bar">
                        <div className="me-rating-label">
                            <small>Сила:</small>
                            <small className="me-rating-value">{ratingLabel}</small>
                        </div>
                        <div className="me-rating-dots align-items-center">
                            {Array.from({ length: 10 }, (_, i) => i + 1).map((value) => (
                                <span
                                    key={value}
                                    className={`me-rating-dot ${value <= rating ? 'active' : ''}`}
                                />
                            ))}
                            {rating === 10 && (
                                <span
                                    className="me-rating-checkmark"
                                    style={{
                                        width: 20,
                                        height: 20,
                                        borderRadius: '50%',
                                        backgroundColor: isFinal ? PRIMARY_COLOR : '#6c757d',
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        marginLeft: 4,
                                    }}
                                >
                                    <FontAwesomeIcon icon={faCircleCheck} style={{ color: 'white', fontSize: '12px' }} />
                                </span>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
